import { render } from "./OfferDetails.vue?vue&type=template&id=d59f16d2&scoped=true&ts=true"
import script from "./OfferDetails.vue?vue&type=script&lang=ts"
export * from "./OfferDetails.vue?vue&type=script&lang=ts"

import "./OfferDetails.vue?vue&type=style&index=0&id=d59f16d2&scoped=true&lang=scss"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d59f16d2"]])

export default __exports__